var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_vm._v("\n  Copyright © 2012 - "+_vm._s(new Date().getUTCFullYear())+" GC集團 Ltd All Rights\n  Reserved."+_vm._s(_vm.version)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }